"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = __importDefault(require("../auth"));
const base_1 = __importDefault(require("./base"));
/**
 * Superclass with Auth container.
 */
class Api extends base_1.default {
    constructor(config, req, auth) {
        super(config, req);
        this.auth = auth || new auth_1.default(this.config, this.req);
    }
}
exports.default = Api;
//# sourceMappingURL=index.js.map